module.exports = __webpack_public_path__ + "media/images/menu/microphone-39f7d19b0c7c4d7629f535cf5a179a0b.svg";